export function voucherDisplayName(venueId: string, displayName: string): string {
    return shouldShowVoucherVenueName(venueId) ? displayName : 'Salt'
}

export function shouldShowVoucherVenueName(venueId: string): boolean {
    return venueId !== 'e34ac8c4-f598-408b-9235-d47078c2a68a'
        && venueId !== '11170d6d-9ff9-4933-8742-8f6da2f99f0d'
}
